
import request from '../request';
const updateUserInfo = (data) => {
    return request.post('/api/wx/auth/updateUserInfo', data)
}
// 身份信息认证
const bindCard = (data) => {
    return request.post('/api/wx/auth/bindCard', data)
}
// ocr识别身份证信息
const ocrGetIdInfo = (data) => {
    return request.post('/api/wx/auth/ocrGetIdInfo', data)
}
// 上传身份证正反面
const uploadIdCard = (data) => {
    return request.post('/api/wx/auth/uploadIdCardInfo', data)
}

// 查询已上传的证件图片
const getIdImageInfo = (data) => {
    return request.post('/api/wx/auth/getIdImageInfo', data)
}

// 对象数组
export default {
    updateUserInfo,
    bindCard,
    ocrGetIdInfo,
    uploadIdCard,
    getIdImageInfo
};